import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import AllocationStatusActionableFilterPill from '../../../../components/actionable-filter-pill/connected/orders/allocation-status';
import { messages } from './messages';

export const AllocationStatus = {
  id: 'allocationStatus',
  isInventoryFilter: true,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'AllocationStatus',
  displayName: <FormattedMessage {...messages.allocationStatus} />,
  allowsMultipleSelection: true,
  expectsArgumentAsArray: true,
  shouldHideActionButtons: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  actionableFilterPill: AllocationStatusActionableFilterPill,

  // API returns collection values as strings and legacy boolean values as booleans; cast to number
  // so Redux state and the pill display correctly. The two call sites pass different first args:
  // mapFilters passes the whole filter object {column, value}; mapCollectionFilters passes the raw value.
  mapV2SavedFilterToV3Applied: (filterOrValue) => {
    const value = filterOrValue?.value ?? filterOrValue;
    return { criterionArgumentValue: Number(value) };
  },
};
